import { Box } from '@mui/material'
import { useHomePageConfiguration } from '../atoms/homePageSupport'
import { useKeyPageSegmentHandler } from '../atoms/homeStatus'

const HomePageSegmentsHandler = () => {
    const config = useHomePageConfiguration()
    // console.log('HomePageSegmentsHandler =>', config)
    const key = useKeyPageSegmentHandler()
    return (
        <>
            <Box key={key} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', overflow: 'auto', gap: 1, height: '100%' }}>
                {config && config.map(s => s.element)}
            </Box>
        </>
    )
}

export default HomePageSegmentsHandler

